/**
 * Fork overlay (new file, no OSS equivalent) — EVA-M7 (7.1).
 * Account-level Eva settings singular resource (/api/v1/accounts/:account_id/eva/settings) —
 * the per-account kill-switch (eva_enabled). Singular: no id in the path.
 */
/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class EvaAccountSettingsAPI extends ApiClient {
  constructor() {
    super('eva/settings', { accountScoped: true });
  }

  // Singular resource: PATCH the base url (no :id), unlike ApiClient#update(id, data). `get()` is
  // inherited as-is (it already GETs this.url).
  update(payload) {
    return axios.patch(this.url, payload);
  }
}

export default new EvaAccountSettingsAPI();
